function sanitizeDropdownValueForDataLayer(element: HTMLElement, value: string): string {
  const isPii = element.dataset.ispii === 'true';
  return isPii ? 'PII Redacted' : value;
}

export default sanitizeDropdownValueForDataLayer;
